import {styled} from "@mui/material";

export const UserAddressesContainer = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
    }
});
